<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="订单id" prop="orderId">
        <a-input-number v-model="form.orderId" placeholder="请输入订单id" style="width: 100%" :min="1" />
      </a-form-model-item>
      <a-form-model-item label="支付状态" prop="status">
        <a-select v-model="form.status" placeholder="请选择">
          <a-select-option :value="0">未支付</a-select-option>
          <a-select-option :value="1">已支付</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="类型" prop="type">
        <a-select v-model="form.type" placeholder="请选择">
          <a-select-option :value="0">加</a-select-option>
          <a-select-option :value="1">减</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入名称" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="金额" prop="money">
        <a-input-number v-model="form.money" placeholder="请输入金额" style="width: 100%" :min="0" :precision="2" />
      </a-form-model-item>
      <a-form-model-item label="支付时间" prop="payTime">
        <a-date-picker
          v-model="form.payTime"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择支付时间"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入备注" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addOrderPaymentItem, getOrderPaymentItem, updateOrderPaymentItem } from '@/api/order/paymentItem'

export default {
  name: 'CreateForm',
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        orderId: null,
        status: 0,
        type: 0,
        name: null,
        money: null,
        payTime: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        orderId: [{ required: true, message: '订单id不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        money: [{ required: true, message: '金额不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onClose() {
      this.open = false
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        orderId: null,
        status: 0,
        type: 0,
        name: null,
        money: null,
        payTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增订单支付项'
    },
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrderPaymentItem({ id }).then(response => {
        const data = response.data
        this.form = {
          id: data.id,
          orderId: data.orderId,
          status: data.status != null ? data.status : 0,
          type: data.type != null ? data.type : 0,
          name: data.name,
          money: data.money,
          payTime: data.payTime,
          remark: data.remark
        }
        this.open = true
        this.formTitle = '编辑订单支付项'
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const submit = this.form.id != null ? updateOrderPaymentItem(this.form) : addOrderPaymentItem(this.form)
        submit
          .then(() => {
            this.$message.success(this.form.id != null ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>
